import { basicEnum } from "./base";

export const SubscriptionProductChangeStatusEnum = basicEnum([
    {
        label: "Menunggu",
        value: "W", // Waiting
    },
    {
        label: "Disetujui",
        value: "A", // Approved
    },
    {
        label: "Ditolak",
        value: "R", // Rejected
    },
]);

export namespace SubscriptionProductChangeStatusEnum {
    export type Labels = (typeof SubscriptionProductChangeStatusEnum)["labels"][number];
    export type Values = (typeof SubscriptionProductChangeStatusEnum)["values"][number];
}
